import React from 'react'
import { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Forget() {
    const Api = process.env.REACT_APP_API_URL
    const apiKey = process.env.REACT_APP_API_KEY

    const [otp1, setOtp1] = useState("");
    const [otp2, setOtp2] = useState("");
    const [otp3, setOtp3] = useState("");
    const [otp4, setOtp4] = useState("");
    const [isEmail, setIsEmail] = useState(true);
    const [isOtp, setIsOtp] = useState(false);
    const [isResetPassword, setIsResetPassword] = useState(false);
    const [userMail, setUserMail] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const userOtp = otp1 + otp2 + otp3 + otp4;

    // Function to send OTP to email
    const sendOtpToEmail = async () => {
        if (!userMail || !userMail.includes('@')) {
            toast.error('Please enter a valid email address', {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }

        setIsLoading(true);
        try {
            const formData = new FormData();
            formData.append('access_email', 'true');
            formData.append('email', userMail);

            const response = await fetch(`${Api}verifyEmail.php`, {
                method: 'POST',
                body: formData
            });
            const result = await response.json();

            console.log("Send OTP Response:", result);

            if (result.success === true) {
                localStorage.setItem('otpmail', userMail);
                // Store OTP for verification (only for development - remove in production)
                if (result.otp) {
                    localStorage.setItem('sentOtp', result.otp);
                }
                toast.success(result.message || 'OTP sent successfully to your email', {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setIsEmail(false);
                setIsOtp(true);
            } else {
                toast.error(result.message || 'Failed to send OTP', {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            console.error("Send OTP Error:", error);
            toast.error('Network error. Please try again.', {
                position: toast.POSITION.TOP_RIGHT,
            });
        } finally {
            setIsLoading(false);
        }
    };

    // Function to verify OTP
    const submitOtp = async () => {
        const mail = localStorage.getItem('otpmail');

        if (!otp1 || !otp2 || !otp3 || !otp4) {
            toast.error('Please enter all OTP digits', {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }

        setIsLoading(true);
        try {
            const response = await fetch(`${Api}verifyOTP.php?email=${mail}&otp=${userOtp}&type=forgetPassword`);
            const result = await response.json();

            console.log("Verify OTP Response:", result);

            if (result.error === "200") {
                toast.success(result.message || 'OTP verified successfully', {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setIsOtp(false);
                setIsResetPassword(true);
            } else {
                toast.error(result.message || 'Invalid OTP', {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            console.error("Verify OTP Error:", error);
            toast.error('Network error. Please try again.', {
                position: toast.POSITION.TOP_RIGHT,
            });
        } finally {
            setIsLoading(false);
        }
    };


    const resetPassword = async () => {
        const mail = localStorage.getItem('otpmail');

        if (!mail) {
            toast.error('Email not found. Please request OTP again.', {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }

        if (!newPassword || !confirmPassword) {
            toast.error('Please fill in both password fields', {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }

        if (newPassword.length < 6) {
            toast.error('Password must be at least 6 characters long', {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }

        if (newPassword !== confirmPassword) {
            toast.error('Passwords do not match', {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }

        setIsLoading(true);
        try {
            const response = await fetch(`${Api}resetPassword.php?email=${encodeURIComponent(mail)}&password=${encodeURIComponent(newPassword)}`, {
                method: 'GET',
            });

            const result = await response.json();
            console.log("Reset Password Response:", result);

            if (result.error === "200") {
                toast.success(result.message || 'Password reset successfully', {
                    position: toast.POSITION.TOP_RIGHT,
                });
                localStorage.removeItem('otpmail');
                setTimeout(() => {
                    window.location.href = "/login";
                }, 2000);
            } else {
                toast.error(result.message || 'Failed to reset password', {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            console.error("Reset Password Error:", error);
            toast.error('Network error. Please try again.', {
                position: toast.POSITION.TOP_RIGHT,
            });
        } finally {
            setIsLoading(false);
        }
    };


    // Function to handle OTP input auto-focus
    const handleOtpInput = (value, currentInput, nextInput, setCurrentOtp) => {
        if (value.length === 1 && nextInput) {
            document.getElementById(nextInput).focus();
        }
        setCurrentOtp(value);
    };

    // Function to go back to previous step
    const goBack = () => {
        if (isResetPassword) {
            setIsResetPassword(false);
            setIsOtp(true);
        } else if (isOtp) {
            setIsOtp(false);
            setIsEmail(true);
            // Clear OTP inputs
            setOtp1("");
            setOtp2("");
            setOtp3("");
            setOtp4("");
        }
    };

    return (
        <div>
            <div className="header">
                <ToastContainer />
                <div className="tf-container">
                    <div className="tf-statusbar br-none d-flex justify-content-center align-items-center">
                        {(isOtp || isResetPassword) && (
                            <a href="javascript:void(0)" onClick={goBack} className="back-btn">
                                <i className="icon-left" />
                            </a>
                        )}
                    </div>
                </div>
            </div>
            <div className="verify-account-section">
                <div className="tf-container">
                    <div>
                        <img src="assets/images/user/register.jpg" alt="images" />
                    </div>

                    {/* Email Input Step */}
                    {isEmail && (
                        <div>
                            <div className="tf-content mt-2">
                                <h3 className="mb-2 text-center">Forgot Password</h3>
                                <p className="text-center">Enter your registered email address to receive OTP</p>
                            </div>
                            <div className="mt-5">
                                <div className="tf-container">
                                    <input
                                        type="email"
                                        onChange={(e) => setUserMail(e.target.value)}
                                        value={userMail}
                                        placeholder="Email Address"
                                        className="tf-input"
                                        disabled={isLoading}
                                    />
                                </div>
                            </div>
                            <button
                                onClick={sendOtpToEmail}
                                className="tf-btn accent large mt-5"
                                disabled={isLoading}
                            >
                                {isLoading ? 'SENDING...' : 'SEND OTP'}
                            </button>
                        </div>
                    )}

                    {/* OTP Verification Step */}
                    {isOtp && (
                        <div>
                            <div className="tf-content mt-2">
                                <h3 className="mb-2 text-center">Verify OTP</h3>
                                <p className="text-center">Enter the 4-digit code sent to your email</p>
                            </div>
                            <div className="mt-5">
                                <div className="tf-container">
                                    <form className="tf-form tf-form-verify">
                                        <div className="d-flex group-input-verify">
                                            <input
                                                type="tel"
                                                maxLength="1"
                                                pattern="[0-9]"
                                                className="input-verify"
                                                id="otp1"
                                                value={otp1}
                                                onChange={(e) => handleOtpInput(e.target.value, 'otp1', 'otp2', setOtp1)}
                                                disabled={isLoading}
                                            />
                                            <input
                                                type="tel"
                                                maxLength="1"
                                                pattern="[0-9]"
                                                className="input-verify"
                                                id="otp2"
                                                value={otp2}
                                                onChange={(e) => handleOtpInput(e.target.value, 'otp2', 'otp3', setOtp2)}
                                                disabled={isLoading}
                                            />
                                            <input
                                                type="tel"
                                                maxLength="1"
                                                pattern="[0-9]"
                                                className="input-verify"
                                                id="otp3"
                                                value={otp3}
                                                onChange={(e) => handleOtpInput(e.target.value, 'otp3', 'otp4', setOtp3)}
                                                disabled={isLoading}
                                            />
                                            <input
                                                type="tel"
                                                maxLength="1"
                                                pattern="[0-9]"
                                                className="input-verify"
                                                id="otp4"
                                                value={otp4}
                                                onChange={(e) => handleOtpInput(e.target.value, 'otp4', null, setOtp4)}
                                                disabled={isLoading}
                                            />
                                        </div>
                                        <div className="text-send-code">
                                            <p className="fw_4">A code has been sent to {userMail}</p>
                                            <button
                                                type="button"
                                                onClick={sendOtpToEmail}
                                                className="btn-link"
                                                disabled={isLoading}
                                                style={{ background: 'none', border: 'none', color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }}
                                            >
                                                Resend OTP
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <button
                                onClick={submitOtp}
                                className="tf-btn accent large mt-5"
                                disabled={isLoading}
                            >
                                {isLoading ? 'VERIFYING...' : 'VERIFY OTP'}
                            </button>
                        </div>
                    )}

                    {/* Password Reset Step */}
                    {isResetPassword && (
                        <div>
                            <div className="tf-content mt-2">
                                <h3 className="mb-2 text-center">Reset Password</h3>
                                <p className="text-center">Enter your new password</p>
                            </div>
                            <div className="mt-5">
                                <div className="tf-container">
                                    <div className="mb-3">
                                        <input
                                            type="password"
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            value={newPassword}
                                            placeholder="New Password"
                                            className="tf-input"
                                            disabled={isLoading}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <input
                                            type="password"
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            value={confirmPassword}
                                            placeholder="Confirm New Password"
                                            className="tf-input"
                                            disabled={isLoading}
                                        />
                                    </div>
                                </div>
                            </div>
                            <button
                                onClick={resetPassword}
                                className="tf-btn accent large mt-5"
                                disabled={isLoading}
                            >
                                {isLoading ? 'RESETTING...' : 'RESET PASSWORD'}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Forget